export default function Imprint(){
    return (
        <div style={{textAlign: 'center', width: '100%', margin: 'auto'}}>
            <div>
                Fluctua Records GmbH
            </div>
            <div>
                Amtsgericht Charlottenburg | HRB 210945B
            </div>
            <div>
                Geschäftsführer: Denís Graña Fernández
            </div>
        </div>
    )
}